import React from 'react';
import { UtensilsCrossedIcon } from 'lucide-react';
const segments = ['6 volumes + 5 bonuses', 'One-time payment', 'English PDF materials'];
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full bg-red-500 text-white" data-id="element-30" data-mp="2vetp68oj8fda">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-1.5 gap-y-1 px-3 py-1.5 text-center text-[9px] font-bold uppercase leading-none tracking-[0.08em] sm:gap-2 sm:px-4 sm:py-2 sm:text-xs sm:tracking-[0.14em]" data-id="element-31" data-mp="2vcz2aotpad6k">
        <UtensilsCrossedIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-32" data-mp="2her82oo1tpz3" />
        {segments.map((segment, index) => <span key={segment} className="flex items-center gap-1.5 whitespace-nowrap sm:gap-2" data-id="element-33" data-mp="2cgz6t41ikri8" data-mpi={index}>
            <span data-id="element-34" data-mp="28fxihi94xzv1">{segment}</span>
            {index < segments.length - 1 && <span aria-hidden="true" className="opacity-70" data-id="element-35" data-mp="aoks0du9o361">
                ·
              </span>}
          </span>)}
      </div>
    </div>;
}